module.exports = __webpack_public_path__ + "static/media/bookmarkappSS.b394ef5f.jpg";